export function extractStringFromQuery(query, key) {
  const value = query[key];
  if (!value) {
    return undefined;
  }
  if (Array.isArray(value)) {
    return value[0];
  }
  return value;
}
export function extractStringArrayFromQuery(query, key) {
  const value = query[key];
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}